<template>
<!-- eslint-disable max-len -->
<narrative-player :individual-decision="individualDecision" :on-complete="onComplete"></narrative-player>
</template>

<script>
import { mapGetters } from 'vuex';

import NarrativePlayer from '../narrative/NarrativePlayer';

export default {
  components: {
    NarrativePlayer
  },
  computed: {
    ...mapGetters([
      'individualDecision'
    ])
  },
  methods: {
    async onComplete() {
      this.$router.nextGameState();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/pages/IndividualDecision.vue